document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".trelli-subscription").forEach(root => {

    const subscriptionEnabled = root.dataset.subscriptionEnabled === "true";

    const tabOneTime = root.querySelector('[data-trelli-tab="one-time"]');
    const tabSubscribe = root.querySelector('[data-trelli-tab="subscribe"]');
    const content = root.querySelector("[data-trelli-content]");

    const buyboxContainer = document.querySelector(".product-form__buy-buttons");
    const buyboxSubmit = document.querySelector(".product-form__controls-group--submit");
    const buyboxDynamic = document.querySelector(".product-form__dynamic-buttons");
    const stickyBuybox = document.querySelector(".product-form__button--fixed");

    function showBuyboxButtons(show) {
      const displayValue = show ? "" : "none";
      if (buyboxContainer) buyboxContainer.style.display = displayValue;
      if (buyboxSubmit) buyboxSubmit.style.display = displayValue;
      if (buyboxDynamic) buyboxDynamic.style.display = displayValue;
      if (stickyBuybox) stickyBuybox.style.display = displayValue;
    }

    // Si NO hay suscripción → dejar todo como está y salir
    if (!subscriptionEnabled) {
      if (tabSubscribe) {
        tabSubscribe.disabled = true;
        tabSubscribe.style.opacity = "0.4";
        tabSubscribe.style.cursor = "not-allowed";
      }
      return;
    }

    // Estado inicial
    content.hidden = true;
    showBuyboxButtons(true);

    tabOneTime.addEventListener("click", () => {
      tabOneTime.classList.add("trelli-tab--active");
      tabSubscribe.classList.remove("trelli-tab--active");
      content.hidden = true;
      showBuyboxButtons(true);
    });

    tabSubscribe.addEventListener("click", () => {
      tabSubscribe.classList.add("trelli-tab--active");
      tabOneTime.classList.remove("trelli-tab--active");
      content.hidden = false;
      showBuyboxButtons(false);
    });
  });
});

// -----------------------------
// URL LOGIC
// -----------------------------
(function () {

  function pickUrl(root) {
    const zone = root.querySelector('[data-trelli-zone]')?.value || 'na';
    const freq = root.querySelector('[data-trelli-frequency]')?.value;
    if (!freq) return "";

    const flavorSelect = root.querySelector('[data-trelli-flavor]');
    const hasFlavor = root.getAttribute("data-has-flavor") === "true";

    if (hasFlavor && flavorSelect) {
      const flavor = flavorSelect.value;
      return root.getAttribute(`data-url-${zone}-${freq}-${flavor}`) || "";
    }

    return root.getAttribute(`data-url-${zone}-${freq}-general`) || "";
  }

  function update(root) {
    const cta = root.querySelector("[data-trelli-cta]");
    if (!cta) return;

    const url = pickUrl(root);
    cta.href = url || "#";
    cta.classList.toggle("is-disabled", !url);
  }

  function bind(root) {
    root.querySelectorAll("select").forEach(sel =>
      sel.addEventListener("change", () => update(root))
    );
    update(root);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-trelli]").forEach(root => bind(root));
  });

})();
